import qs from 'qs';

function buildParams(params) {
  return qs.stringify(params, { encode: false });
}

function buildUrl(url, querystring) {
  if (!querystring) {
    return url;
  }

  return `${url}?${querystring}`;
}

function cleanParams(otherParams) {
  if (typeof otherParams === 'string' && otherParams.charAt(0) === '?') {
    return otherParams.substring(1);
  }

  return otherParams;
}

function getProjectBase(pathname = '/') {
  let pathnameArray = pathname.split('/');

  if (pathnameArray.length === 1 || pathname[0] !== '/') {
    return pathnameArray[0];
  } else {
    return pathnameArray[1];
  }
}

function customizeSignIn(otherParams, paramsToBuild) {
  if (otherParams.includes('utm_campaign=applynow') || otherParams.includes('inviteId')) {
    // If user comes from clicking "Apply Now" or invitation url, we want to customize the sign in page
    paramsToBuild['he'] = encodeURIComponent('Apply to this property');
    paramsToBuild['sh'] = encodeURIComponent('Please sign in or create an account to securely apply.');
  } else if (
    paramsToBuild.url.match('rental-manager%2Fproperties%2F.+%2Fapplications') ||
    paramsToBuild.url.match('renter-hub%2Fapplications')
  ) {
    paramsToBuild['he'] = encodeURIComponent('Continue to Applications');
    paramsToBuild['sh'] = encodeURIComponent('Please sign in to securely manage your rental applications.');
  } else if (
    paramsToBuild.url.match('rental-manager%2Fproperties%2F.+%2Fpayments') ||
    paramsToBuild.url.match('rental-manager%2Fpayments') ||
    paramsToBuild.url.match('renter-hub%2Fpayments')
  ) {
    paramsToBuild['he'] = encodeURIComponent('Continue to Payments');
    paramsToBuild['sh'] = encodeURIComponent('Please sign in to securely manage your rental payments.');
  }

  return paramsToBuild;
}

function customizePasswordReset(otherParams, paramsToBuild) {
  const { isZillowApp } = qs.parse(otherParams, { ignoreQueryPrefix: true });
  if (isZillowApp === 'true') {
    paramsToBuild.fromApp = true;
  }

  return paramsToBuild;
}

export default {
  hotpads: {
    signInPage: (toUrl, otherParams) => {
      const params = qs.parse(cleanParams(otherParams));
      return buildUrl(
        '/login',
        buildParams({
          redirect: toUrl,
          ...params,
        }),
      );
    },
    passwordResetPage: (toUrl, otherParams) => {
      const params = qs.parse(cleanParams(otherParams));
      return buildUrl(
        '/user/update-password',
        buildParams({
          redirect: toUrl,
          ...params,
        }),
      );
    },
    twoFactorAuthPage: (toUrl, otherParams) => {
      const params = qs.parse(cleanParams(otherParams));
      const projectBase = getProjectBase(toUrl);

      return buildUrl(
        `/${projectBase}/2fa`,
        buildParams({
          redirect: toUrl,
          ...params,
        }),
      );
    },
  },

  zillow: {
    signInPage: (toUrl, otherParams, zillowCustomLoginPagePath = '') => {
      const paramsToBuild = {
        url: encodeURIComponent(toUrl + otherParams),
      };
      const params = buildParams(customizeSignIn(otherParams, paramsToBuild));
      return buildUrl(zillowCustomLoginPagePath || '/user/acct/login/', params);
    },
    nativeAppSignInPage: (toUrl, otherParams) => {
      const params = buildParams({
        url: encodeURIComponent(toUrl + otherParams),
      });
      return buildUrl('/renter-hub/nativeAppSignInPage', params);
    },
    passwordResetPage: (toUrl, otherParams) => {
      const paramsToBuild = {
        url: encodeURIComponent(toUrl + otherParams),
      };
      const params = buildParams(customizePasswordReset(otherParams, paramsToBuild));
      return buildUrl('/myzillow/ChangePassword.htm', params);
    },
    twoFactorAuthPage: (toUrl, otherParams) => {
      const paramsToBuild = {
        url: encodeURIComponent(toUrl + otherParams),
      };
      const params = buildParams(customizeSignIn(otherParams, paramsToBuild));
      return buildUrl('/user/acct/login/', params);
    },
  },

  trulia: {
    signInPage: (toUrl, otherParams) => buildUrl(`/login/r${toUrl}`, cleanParams(otherParams)),
    passwordResetPage: (toUrl, otherParams) => buildUrl(`/login/r${toUrl}`, cleanParams(otherParams)),
    twoFactorAuthPage: (toUrl, otherParams) => {
      const params = buildParams({
        redirect: encodeURIComponent(toUrl + otherParams),
      });
      const projectBase = getProjectBase(toUrl);

      buildUrl(`/${projectBase}/2fa`, params);
    },
  },
};
